<template>
    <form method="post" @submit.prevent="onSubmit">
        <div class="form-block--secondary">
            <div class="form__row">
                <div class="form__item">
                    <building-autocomplete ref="building" :v="$v" @change="onChange" name="form.buildingId" v-model="$v.form.buildingId.$model" length-type="w--m"/>
                    <div class="z1">
                        <button type="button" @click="createBuilding" iconic class="m--t-1"><span icon create></span>Založit budovu</button>
                    </div>
                </div>
                <div class="form__item">
                    <form-input label="Patro" :v="$v" name="form.floorNumber" @change="onChange" v-model="$v.form.floorNumber.$model" :disabled="!$v.form.buildingId.$model" length-type="w--xxs"/>
                </div>
            </div>
        </div>
        <div class="elementary-section__controls button-fix">
            <custom-button type="submit" small outline v-bind:class="{'no-updates': !formChanged}">Uložit
            </custom-button>
        </div>
    </form>
</template>

<script>
import {numeric} from 'vuelidate/lib/validators';
import FormInput from 'domovio-core/src/components/Form/Input/FormInput';
import BuildingAutocomplete from '@/components/Autocomplete/BuildingAutocomplete';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';
import CreateBuildingDialog
    from '@/modules/ProjectModule/modules/OptionModule/components/Building/CreateBuildingDialog';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';

export default {
    name:        'BuildingForm',
    components:  {
        CustomButton,
        BuildingAutocomplete,
        FormInput,
    },
    data() {
        return {
            formChanged: false,
            form:        {
                buildingId:  null,
                floorNumber: null,
            },
        }
    },
    validations: {
        form: {
            floorNumber: { numeric },
            buildingId:  {},
        },
    },
    computed:    {
        buildingId() {
            return this.$store.getters['projects/project/units/unit/buildingId'];
        },
        unitData() {
            return this.$store.getters['projects/project/units/unit/unitData'];
        }
    },
    mounted() {
        const { floorNumber } = this.unitData;
        this.form.floorNumber = floorNumber;
        this.$refs.building.setSelectedId(this.buildingId);
    },
    methods:     {
        onSubmit() {
            this.$v.$touch();
            if (false === this.$v.$invalid) {
                const { floorNumber, buildingId } = this.form;
                this.$emit('o3-submit', { buildingId, floorNumber: parseInt(floorNumber) });
            }
        },
        onChange() {
            this.formChanged = true;
        },
        createBuilding() {
            this.$modal.show(CreateBuildingDialog, {}, defaultModalParameters());
        }
    }
}
</script>
